import { createContext } from "react"

const Token = createContext({})

export default Token
